module.exports = __webpack_public_path__ + "static/WEDDING E&M-594-24b7403f6f743ede0d506191a18876e0.jpg";